module.exports = __webpack_public_path__ + "static/praxisDetail-b7bc2b2bd6d700079cdc8f9b288b0aa2.jpg";